/* WARNING: This file is auto-generated from Figma design tokens, do not manually update this file */
/* alias - use as "@ions-interface" */

export enum Context {
  LIGHT = "light",
  DARK = "dark"
}

export enum PillFillStyle {
  FILLED = "filled",
  OUTLINE = "outline"
}

export enum PillVariant {
  STANDARD = "standard",
  ACCENT = "accent",
  TRANSPARENT_LIGHT = "transparent-light",
  TRANSPARENT_DARK = "transparent-dark",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error"
}

export enum ButtonVariant {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  TERTIARY = "tertiary",
  TEXT = "text",
  TEXT_PRIMARY = "text-primary",
  TEXT_INVERT = "text-invert",
  TEXT_DANGER = "text-danger",
  DANGER = "danger",
  SUCCESS = "success"
}

export enum ButtonSize {
  DEFAULT = "default",
  SMALL = "small",
  MINIMAL = "minimal"
}

export enum PageTitleAccentType {
  LINE = "line",
  CUSTOM = "custom"
}

export enum NavItemAccentType {
  LINE = "line",
  FOLD = "fold"
}

export enum InputBorderStyle {
  FULL = "full",
  NONE = "none",
  NONE_WITH_PADDING = "none-with-padding"
}

export type HostIons = {
  context?: {
    fallback?: Context;
    default?: {
      primaryNav?: Context;
      secondaryNav?: Context;
      pageTitle?: Context;
      pageBody?: Context;
      box?: Context;
      modal?: Context;
      sidePanel?: Context;
      contentDisplay?: Context;
    };
    clientDashboard?: {
      pageTitle?: Context;
      pageBody?: Context;
      box?: Context;
      modal?: Context;
      sidePanel?: Context;
      contentDisplay?: Context;
    };
  };
  components?: {
    organisms?: {
      workflow?: { step_container?: { button_variant?: ButtonVariant } };
      nav?: { top?: { item?: { accent_type?: NavItemAccentType } } };
      modal?: {
        submit?: { button_variant?: ButtonVariant };
        cancel?: { button_variant?: ButtonVariant };
      };
    };
    atoms?: {
      page_title?: { heading?: { accent_type?: PageTitleAccentType } };
      draft_pill?: {
        pill_variant?: PillVariant;
        pill_fill_style?: PillFillStyle;
      };
    };
    molecules?: {
      milestones?: { update_button_variant?: ButtonVariant };
      project_template_panel?: {
        pill_variant?: PillVariant;
        pill_fill_style?: PillFillStyle;
        active?: {
          pill_variant?: PillVariant;
          pill_fill_style?: PillFillStyle;
        };
      };
      project_panel?: {
        pill_variant?: PillVariant;
        pill_fill_style?: PillFillStyle;
        draft?: { pill_variant?: PillVariant; pill_fill_style?: PillFillStyle };
      };
      inputs?: {
        dropdown?: {
          context_light?: {
            pill_variant?: PillVariant;
            pill_fill_style?: PillFillStyle;
          };
          context_nav?: {
            pill_variant?: PillVariant;
            pill_fill_style?: PillFillStyle;
          };
          context_dark?: {
            pill_variant?: PillVariant;
            pill_fill_style?: PillFillStyle;
          };
        };
      };
      action_item_panel?: {
        pill_variant?: PillVariant;
        pill_fill_style?: PillFillStyle;
      };
    };
    templates?: {
      page_filter?: {
        input?: { border_style?: InputBorderStyle };
        pill?: {
          active?: {
            pill_variant?: PillVariant;
            pill_fill_style?: PillFillStyle;
          };
          inactive?: {
            pill_fill_style?: PillFillStyle;
            pill_variant?: PillVariant;
          };
        };
      };
      content_container?: { header?: { button_variant?: ButtonVariant } };
      kanban?: { swimlane?: { action?: { button_variant?: ButtonVariant } } };
    };
  };
};
